export default __webpack_public_path__ + "static/cekmekoy-rest-4-273c264c38348d913674c22c9c8913b7.jpg";